import { useFarm } from 'app/agriculture/hooks/useFarm/useFarm';
import { useMemo } from 'react';

export function useTimeZone() {
    const {
        farm: { timeZone },
    } = useFarm();

    return useMemo(() => ({ timeZone }), [timeZone]);
}
